import { useState, useEffect, useRef } from "react";
import { Outlet } from "react-router";
import AccountRestrictedModal from "../components/auth/AccountRestrictedModal";
import Sidebar from "../components/dashboard/Sidebar";
import Navbar from "../components/dashboard/Navbar";
import ScrollToTop from "../components/dashboard/ScrollToTop";
import useSidebarCollapsed from "../hooks/useSidebarCollapsed";
import { PortfolioProvider } from "../context/PortfolioContext";
import { usePortalPulse } from "../hooks/useLiveRefresh";

export default function DashboardLayout() {
  usePortalPulse();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { collapsed: sidebarCollapsed, toggle: toggleSidebar } = useSidebarCollapsed();
  const mainScrollRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    if (!mobileNavOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setMobileNavOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [mobileNavOpen]);

  return (
    <PortfolioProvider>
      <div className="flex h-dvh overflow-hidden bg-surface">
        <AccountRestrictedModal />
        <div className="hidden shrink-0 lg:flex">
          <Sidebar collapsed={sidebarCollapsed} />
        </div>

        {mobileNavOpen && (
          <button
            type="button"
            className="fixed inset-0 z-40 bg-primary/40 backdrop-blur-sm lg:hidden"
            aria-label="Close navigation"
            onClick={() => setMobileNavOpen(false)}
          />
        )}
        <div
          className={`
            fixed inset-y-0 left-0 z-50 transition-transform duration-300 ease-out lg:hidden
            ${mobileNavOpen ? "translate-x-0" : "-translate-x-full"}
          `}
        >
          <Sidebar onNavigate={() => setMobileNavOpen(false)} />
        </div>

        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <Navbar
            onMenuClick={() => setMobileNavOpen(true)}
            sidebarCollapsed={sidebarCollapsed}
            onSidebarToggle={toggleSidebar}
          />

          <main
            ref={mainScrollRef}
            className="dashboard-main-scroll min-h-0 flex-1 overflow-y-auto overflow-x-hidden"
          >
            <ScrollToTop containerRef={mainScrollRef} />
            <Outlet />
          </main>
        </div>
      </div>
    </PortfolioProvider>
  );
}
